var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Others",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3383",
    "data-name": "Rectangle 3383",
    width: 20,
    height: 20,
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3567",
    "data-name": "Group 3567",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M7.935,1.333A.065.065,0,0,1,8,1.4V7.935A.065.065,0,0,1,7.935,8H1.4a.065.065,0,0,1-.065-.065V1.4A.065.065,0,0,1,1.4,1.333ZM7.935,0H1.4A1.4,1.4,0,0,0,0,1.4V7.935a1.4,1.4,0,0,0,1.4,1.4H7.935a1.4,1.4,0,0,0,1.4-1.4V1.4A1.4,1.4,0,0,0,7.935,0",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M7.935,161.333A.065.065,0,0,1,8,161.4v6.537a.065.065,0,0,1-.065.065H1.4a.065.065,0,0,1-.065-.065V161.4a.065.065,0,0,1,.065-.065Zm0-1.333H1.4A1.4,1.4,0,0,0,0,161.4v6.537a1.4,1.4,0,0,0,1.4,1.4H7.935a1.4,1.4,0,0,0,1.4-1.4V161.4a1.4,1.4,0,0,0-1.4-1.4",
    transform: "translate(0 -149.333)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M164.667,161.333a3.333,3.333,0,1,1-3.333,3.333,3.337,3.337,0,0,1,3.333-3.333m0-1.333h0a4.667,4.667,0,1,0,4.667,4.667A4.667,4.667,0,0,0,164.667,160",
    transform: "translate(-149.333 -149.333)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M167.935,1.333A.065.065,0,0,1,168,1.4V7.935a.065.065,0,0,1-.065.065H161.4a.065.065,0,0,1-.065-.065V1.4a.065.065,0,0,1,.065-.065Zm0-1.333H161.4A1.4,1.4,0,0,0,160,1.4V7.935a1.4,1.4,0,0,0,1.4,1.4h6.537a1.4,1.4,0,0,0,1.4-1.4V1.4a1.4,1.4,0,0,0-1.4-1.4",
    transform: "translate(-149.333)",
    fill: "#333"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/Others.70f1c2f5d7749d1eac1b7304f012caf7.svg";
export { ForwardRef as ReactComponent };